import { jsxs as V, jsx as s } from "react/jsx-runtime";
import { useForm as v, useController as G } from "react-hook-form";
import { useState as U, useEffect as w, Fragment as O } from "react";
import "dayjs";
import { useTranslation as D } from "react-i18next";
import { isArrayWithItems as y } from "../../../helpers/array-helper.js";
import "../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButton as _ } from "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { HookFormCheckboxGroup as j } from "../hook-form/hook-form-checkbox-group.js";
import { HookFormFileUpload as W } from "../hook-form/hook-form-file-upload.js";
import { HookFormInputField as q } from "../hook-form/hook-form-input-field.js";
import { HookFormSelect as z } from "../hook-form/hook-form-select.js";
import { HookFormTextArea as J } from "../hook-form/hook-form-text-area.js";
import { AlertSummary as C } from "../../elements/alert-summary/alert-summary.js";
import { getErrorsFromHookFormError as K } from "../../../helpers/form-helper.js";
import { HookFormRadioButtonGroup as P } from "../hook-form/hook-form-radio-button-group.js";
import Q from "../components/accept-terms/accept-terms.js";
const k = (e) => e.type !== "content", X = (e, r) => {
  if (e.renderCondition && e.renderCondition.dependency.size > 0) {
    let o = !1;
    for (const [t, n] of e.renderCondition.dependency.entries())
      if (r && r[t] && (o = n.includes(r[t])), o)
        return !0;
    return o;
  }
  return !0;
}, Y = (e) => e.filter((t) => k(t)).reduce((t, n) => (n.type === "select" && !n.defaultValue && y(n.items) ? t[n.name] = n.items[0].value : n.type === "checkbox" && !n.defaultValue ? t[n.name] = [] : n.defaultValue && (t[n.name] = n.defaultValue), t), {}), Z = ({
  acceptTerms: e,
  labels: r,
  isPostingForm: o,
  onSubmitForm: t,
  control: n
}) => {
  const { t: u } = D();
  if (e) {
    const { field: l } = G({
      name: "acceptTerms",
      control: n,
      rules: { required: !0 },
      shouldUnregister: !0
    });
    return /* @__PURE__ */ s(
      Q,
      {
        title: e.title,
        isPostingForm: o,
        onSubmitForm: t,
        termsContent: e.termsContent,
        submitButtonText: r?.submitButtonText ?? u("SEND"),
        submitButtonLoadingText: r?.submitButtonLoadingText ?? u("SENDING"),
        checkboxProps: {
          name: l.name,
          value: l.value,
          onChange: l.onChange,
          label: e.acceptTermsLabel,
          isChecked: l.value === !0
        }
      }
    );
  } else
    return /* @__PURE__ */ s(
      _,
      {
        isFullWidth: !0,
        label: o ? r?.submitButtonLoadingText ?? u("SENDING") : r?.submitButtonText ?? u("SEND"),
        isLoading: o,
        onClick: t
      }
    );
}, ye = ({
  form: e,
  initialFormValues: r,
  onFormSubmit: o,
  onFormChange: t,
  isDisabled: n,
  isPostingForm: u,
  formStatus: l,
  labels: S,
  hideSubmitButton: E,
  acceptTerms: i
}) => {
  const { t: c } = D(), p = r || Y(e.fields), { control: b, watch: h, handleSubmit: N, formState: g, reset: M, setValue: B } = v({
    mode: e.mode,
    reValidateMode: e.reValidateMode
  }), x = { reset: M, setValue: B }, { errors: L } = g, d = e.fields.filter((a) => k(a)).reduce((a, m) => (a[m.name] = m.label, a), {});
  i && (d.acceptTerms = i.acceptTermsLabel ?? c("ACCEPT_TERMS"));
  const F = K(L, d, c), [R, I] = U(p);
  w(() => {
    const { unsubscribe: a } = h((m) => {
      I(m), typeof t == "function" && t(m, x);
    });
    return () => a();
  }, [h]);
  const A = (a) => {
    typeof o == "function" && o(a, x);
  };
  return /* @__PURE__ */ V("div", { children: [
    e.fields.map((a) => {
      const m = a.renderCondition ? X(a, R) : !0, T = !m && a.renderCondition?.fieldStateUntilConditionMet === "disabled";
      if (m || T) {
        const H = p[a.name] ?? void 0;
        return /* @__PURE__ */ s(
          $,
          {
            field: a,
            control: b,
            isDisabled: T || n || u,
            defaultValue: H
          },
          a.name
        );
      }
    }),
    y(F) && /* @__PURE__ */ s(C, { className: "mb-md", heading: c("ERROR_MISSING_INFORMATION_HEADING"), messages: F }),
    l && /* @__PURE__ */ s(C, { className: "mb-md", ...l }),
    !E && /* @__PURE__ */ s(
      Z,
      {
        onSubmitForm: N(A),
        isPostingForm: u,
        labels: S,
        acceptTerms: i,
        control: b
      }
    )
  ] });
}, $ = ({
  field: e,
  control: r,
  isDisabled: o,
  defaultValue: t
}) => {
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ s(
        q,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          inputMode: e.inputMode ?? "text",
          label: e.label,
          helperText: e.helperText,
          placeholder: e.placeholder,
          autoComplete: e.autoComplete,
          isDisabled: e.isDisabled || o,
          defaultValue: t
        }
      );
    case "textarea":
      return /* @__PURE__ */ s(
        J,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          label: e.label,
          helperText: e.helperText,
          placeholder: e.placeholder,
          isDisabled: e.isDisabled || o,
          maxLength: e.maxLength,
          minLength: e.minLength,
          defaultValue: t
        }
      );
    case "select":
      return /* @__PURE__ */ s(
        z,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          helperText: e.helperText,
          label: e.label,
          items: e.items,
          isDisabled: e.isDisabled || o,
          defaultValue: t,
          placeholder: e.placeholder
        }
      );
    case "checkbox":
      return /* @__PURE__ */ s(
        j,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          label: e.labelContent ? e.labelContent : e.label,
          helperText: e.helperText,
          isDisabled: e.isDisabled || o,
          checkboxes: e.checkboxes,
          defaultValue: t
        }
      );
    case "radiobutton":
      return /* @__PURE__ */ s(
        P,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          label: e.labelContent ? e.labelContent : e.label,
          helperText: e.helperText,
          isDisabled: e.isDisabled || o,
          defaultValue: t,
          radioButtons: e.radioButtons,
          orientation: e.orientation
        }
      );
    case "fileupload":
      return /* @__PURE__ */ s(
        W,
        {
          control: r,
          name: e.name,
          rules: e.rules,
          label: e.label,
          helperText: e.helperText,
          isDisabled: e.isDisabled || o,
          accept: e.accept,
          allowMultipleFiles: e.allowMultipleFiles,
          defaultValue: t
        }
      );
    case "content":
      return /* @__PURE__ */ s(O, { children: e.value }, e.name);
  }
};
export {
  ye as default
};
